import React from "react";
import PropTypes from "prop-types";

const ShippingCost = (props) => (
  <div className="shipping-cost">
    <h3>{props.header}</h3>
    <p>{props.shippingCost}</p>
  </div>
);

ShippingCost.propTypes = {
  header: PropTypes.string.isRequired,
  shippingCost: PropTypes.string,
};

export default ShippingCost;
